require("../../vendor/jquery.autocomplete.min");
require("sweetalert");

$(document).ready(function() {

	$(".box.active:not(.locked) .box__box-title").on("click", function () {
		$(this).parents(".box").toggleClass("subscriptions-box-closed");
	});

	/*
	 * Auto Scroll to open section
	 */
	if ($(".race-subscribe-steps-container").length) {

		if ($(".login-box").length == 0 && $(".box").length > 0) {

			var scroll_to_target;

			if( $(".box:not(.subscriptions-box-closed)").length ) {

				scroll_to_target = $(".box:not(.subscriptions-box-closed)").position().top;

				if( $(".box:not(.subscriptions-box-closed) .scroll_to_sub_section").length ) {
					scroll_to_target = $(".box:not(.subscriptions-box-closed) .scroll_to_sub_section").position().top;
				}

			}

			$("html, body").animate(
				{ scrollTop: scroll_to_target},
				300
			);
		}
	}

	/*
	 * Populate form from card number
	 */
	function autoCompletePersonlData(racer_card_number) {
		$.get(
			APP_ROOT + "/api/" + LOCALE + "/v1/racers-cards/search",
			{
				racer_card_number: racer_card_number
			},
			function(racer_card) {
				console.log(racer_card)
				if (racer_card) {
					$("#racer_card_number").addClass("card-found");
					$("#racer_card_number").removeClass("card-not-found");

					if (racer_card.name.length) $("#name").val(racer_card.name);
					if (racer_card.surname.length) $("#surname").val(racer_card.surname);
					if (racer_card.birth_date.length) {
						$("#birth_date_day").val(racer_card.birth_date_day);
						$("#birth_date_month").val(racer_card.birth_date_month);
						$("#birth_date_year").val(racer_card.birth_date_year);
					}
					if (racer_card.gender.length > 0) {
						$("#gender").val(racer_card.gender.toLowerCase());
					}

					$("#team_name_non_ita").prop("disabled", true);


					if (racer_card.last_subscription) {

						if (racer_card.last_subscription.fiscal_code)
							$("#fiscal_code").val(racer_card.last_subscription.fiscal_code);

						if (racer_card.last_subscription.address)
							$("#address").val(racer_card.last_subscription.address);

						if (racer_card.last_subscription.city)
							$("#city").val(racer_card.last_subscription.city);

						if (racer_card.last_subscription.state)
							$("#state").val(racer_card.last_subscription.state);

						if (racer_card.last_subscription.postal_code)
							$("#postal_code").val(racer_card.last_subscription.postal_code);

						if (racer_card.last_subscription.country)
							$("#country").val(racer_card.last_subscription.country);

						if (racer_card.last_subscription.phone_number)
							$("#phone_number").val(racer_card.last_subscription.phone_number);

						if (racer_card.last_subscription.email)
							$("#subscribe_email").val(racer_card.last_subscription.email);
					}

					if (typeof racer_card.team !== "undefined") {
						$(".italian-team").addClass("visible");
						$("#team_group").val(racer_card.team.team_group);
						$("#team_name_ita").val(racer_card.team.team_name);
						$("#team_code").val(racer_card.team_code);
						$("#nationality").val("IT");
					}

					displayTeamForm();

				} else {

					console.log('not found')

					$("#racer_card_number").addClass("card-not-found");
					$(".alert-card-not-found").addClass('visible');

				}

			},
			"json"
		);
	}

	// disabilita form submission schicciando enter
	$(document).on("keydown", "form", function(event) {
    	return event.keyCode != 13;
	});

	$(".search-card-code").click( (evt) => {
		
		evt.preventDefault();
		
		$("#racer_card_number").removeClass();
		
		if ($("#racer_card_number").val().length > 4) {
			autoCompletePersonlData($("#racer_card_number").val());
		} else {
			$("#racer_card_number").addClass("card-not-found");
		}

	});

	$("#racer_card_number").bind("keyup focus", function( e ) {
		$("#racer_card_number").removeClass();
	});

	/*
	 * Team Selection
	 */
	$("#no_team").change(function() {
		displayTeamForm();
	});

	if ($("#nationality").val() == "IT") {
		$("#team_name_ita").prop("disabled", false);
		$("#team_name_non_ita").prop("disabled", true);
	}

	displayTeamForm();

	function displayTeamForm() {
		if ($("#no_team").is(":checked")) {
			$(".italian-team").css({ display: "none" });
			$(".non-italian-team").css({ display: "none" });

			$("#team_name_non_ita")
				.prop("disabled", true)
				.val("");
			$("#team_name_ita")
				.prop("disabled", true)
				.val("");
			$("#team_group").val("");
			$("#team_code").val("");
		} else if ($("#nationality").val() == "IT") {
			$("#team_name_non_ita").prop("disabled", true);
			$("#team_name_ita").prop("disabled", false);
			// $("#team_name_ita")
			// 	.autocomplete()
			// 	.setOptions({
			// 		params: {
			// 			team_nationality: $("#nationality").val()
			// 		}
			// 	});
			$(".italian-team").css({ display: "block" });
			$(".non-italian-team").css({ display: "none" });
		} else if ($("#nationality").val() == "") {
			$(".italian-team").css({ display: "none" });
			$(".non-italian-team").css({ display: "none" });
		} else {
			$(".italian-team").css({ display: "none" });
			$(".non-italian-team").css({ display: "block" });

			$("#team_name_ita").prop("disabled", true);
			$("#team_name_non_ita").prop("disabled", false);
		}
	}

	$("#nationality").on('change', function() {
		$("#team_name_ita").val("");
		$("#team_name_non_ita").val("");
		$("#team_code").val("");
		$("#team_group").val("");

		displayTeamForm();
	});

	$("#team_group").on('change', function() {
		$("#team_name_ita").val("");
		$("#team_code").val("");

		// $("#team_name_ita")
		// 	.autocomplete()
		// 	.setOptions({
		// 		params: {
		// 			team_group: $("#team_group").val()
		// 		}
		// 	});
	});

	$("#team_name_ita").autocomplete({
		// lookupLimit: 10,
		showNoSuggestionNotice: true,
		noSuggestionNotice: 'Nessun risultato trovato, inserisci nome e codice team manualmente.',
		minChars: 3,
		serviceUrl: APP_ROOT + "/api/" + LOCALE + "/v1/teams/search",

		transformResult: function(response) {
			return {
				suggestions: $.map(response.suggestions, function(dataItem) {
					return { value: dataItem.team_name, data: dataItem.team_code };
				})
			};
		},

		onSelect: function(suggestion) {
			$("#team_code").val(suggestion.data);
		},
		// onSearchComplete: function( query, suggestions ) {
		// 	if( suggestions.length == 0 ) {
		// 		$("#team_code").val("");
		// 	}
		// },
		onInvalidateSelection: function() {
			$("#team_code").val("");
		},
		preventBadQueries: false,
		dataType: "json",
		deferRequestBy: 300
	});

	$("#no-login-subscription").on('click', function() {
		$(".race-subscribe-steps-container .box")
			.first()
			.removeClass("subscriptions-box-closed");

		$("html, body").animate(
			{ scrollTop: $(".race-subscribe-steps-container").position().top },
			500
		);
	});

	$("input[name=medical_certificate]").on('change', function() {
		$("input[name=skip_medical_certificate]").prop("checked", false);
		$("#upload-certificate").attr("value", text_certificate);
	});

	$("input[name=skip_medical_certificate]").on('change', function() {
		
		var selected_val = $("input[name=skip_medical_certificate]:checked").val();

		if (selected_val == "skip_1") {
			$("#upload-certificate").attr("value", text_skip_certificate);
			$("input[name=medical_certificate]").val("");
		} else if (selected_val == "skip_2") {
			$("#upload-certificate").attr("value", text_skip_certificate);
			$("input[name=medical_certificate]").val("");
		} else if (selected_val == "skip_3") {
			$("#upload-certificate").attr("value", text_skip_certificate);
			$("input[name=medical_certificate]").val("");
		}

	});

	/*
	* Select subscription Fee
	*/

	if (
		$(".box-tickets--subscriptions").length &&
		$("#id_race_category").length
	) {
		$("#id_race_route").change(function() {
			filterSubscriptionTaxes();
		});

		$("#id_race_category").change(function() {
			filterSubscriptionTaxes();
		});

		function filterSubscriptionTaxes() {
			$("#quote-not-found").hide();
			$("#save-sub-fee").hide();
			$(".box-tickets--subscriptions").hide();

			// Deselect all tickets on every filter change (route or category)
			$(".box-tickets--subscriptions .ticket").removeClass("selected");
			$(".box-tickets--subscriptions .ticket input").prop("checked", false);

			var selected_route_id = $("#id_race_route").val();
			var selected_category_id = $("#id_race_category").val();
					var c = 0;
		$(".box-tickets--subscriptions .ticket").each(function() {
			// Check category compatibility with multi-category support and retrocompatibility
			var categoryMatch = false;
			var ticketCategories = $(this).data("categories");

			if (ticketCategories && ticketCategories !== '' && ticketCategories !== '0') {
				// New multi-category system: check if selected category is in the list
				var categoriesArray = String(ticketCategories).split(',').map(function(id) { return id.trim(); });
				categoryMatch = categoriesArray.indexOf(selected_category_id) !== -1;
			} else {
				// Legacy system: use id_race_category field
				categoryMatch = ($(this).data("id_race_category") == selected_category_id || $(this).data("id_race_category") == 0);
			}

			if (
				selected_route_id != "" &&
				selected_category_id != "" &&
				($(this).data("id_race_route") == $("#id_race_route").val() ||
					$(this).data("id_race_route") == 0) &&
				categoryMatch
			) {
				$(this).css("display", ""); // il display lo decide il CSS (griglia della card)
				c++;
			} else {
				$(this).css("display", "none");
				$(this).removeClass("selected");
				$(this)
					.find("input")
					.prop("checked", "");
			}
		});
			if (!c && selected_route_id != "" && selected_category_id != "") {
				$(".box-tickets--subscriptions").hide();
				$("#quote-not-found .alert-box .text span").text("");
				var text =
					" " +
					text_no_quote.first +
					'<span class="bold"> ' +
					$("#id_race_route")
						.find("option:selected")
						.text() +
					"</span>" +
					text_no_quote.second +
					'<span class="bold">' +
					$("#id_race_category")
						.find("option:selected")
						.text() +
					"</span>";
				$("#quote-not-found .alert-box .text span").append(text);
				$("#quote-not-found").show();
			}
			if (c) {
				$(".box-tickets--subscriptions").fadeIn();
			}

			// Auto-select when only one ticket is visible and not sold out
			if (c === 1) {
				var $onlyTicket = $(".box-tickets--subscriptions .ticket:visible");
				if (!$onlyTicket.hasClass("sold-out")) {
					$onlyTicket.addClass("selected");
					$onlyTicket.find("input").prop("checked", true);
					if ($("#custom-fields-container").length) {
						$("#custom-fields-container").fadeIn();
					}
					$("#save-sub-fee").fadeIn();
				}
			}

			if (window.canDiscardAndPay) {
				var discardReason = null;
				if (c > 0) {
					var visibleTickets = $(".box-tickets--subscriptions .ticket:visible");
					var allSoldOut = visibleTickets.length > 0 && visibleTickets.filter(":not(.sold-out)").length === 0;
					if (allSoldOut) {
						discardReason = "sold-out";
					}
				} else if (selected_route_id != "" && selected_category_id != "") {
					// nessuna quota per percorso + categoria (es. fascia d'età non prevista)
					discardReason = "no-quote";
				}

				if (discardReason) {
					$("#discard-and-pay-banner .discard-and-pay__title").hide();
					$('#discard-and-pay-banner [data-reason="' + discardReason + '"]').show();
					$("#discard-and-pay-banner").fadeIn();
				} else {
					$("#discard-and-pay-banner").hide();
				}
			}
		}

		filterSubscriptionTaxes();

		$(".box-tickets--subscriptions .ticket").click(function() {
			$(".ticket").removeClass("selected");
			$(this).addClass("selected");

			$(this)
				.find("input")
				.prop("checked", true);

			// Show custom fields section if it exists
			if ($("#custom-fields-container").length) {
				$("#custom-fields-container").fadeIn();
			}

			$("#save-sub-fee").fadeIn();
		});

		// Quota scelta dalla pagina gara (?quota=ID): se, con percorso e
		// categoria correnti, è tra quelle visibili e nessuna è già
		// selezionata, la seleziona come farebbe il click dell'utente
		var preselectedTax = $(".box-tickets--subscriptions").data("preselected-tax");
		if (preselectedTax && !$(".box-tickets--subscriptions .ticket.selected").length) {
			var $preselected = $('.box-tickets--subscriptions .ticket[data-id_race_subscription_tax="' + preselectedTax + '"]:visible').not(".sold-out");
			if ($preselected.length) {
				$preselected.first().trigger("click");
			}
		}
	}

	/*
	 * Select payment method - New card-based UI
	 */
	if ($(".payment-card").length > 0) {

		// Map frontend payment method names to backend values
		function mapPaymentMethodToBackend(frontendMethod) {
			var mapping = {
				'payment_method_credit_card': 'creditcard',
				'payment_method_apple_pay': 'creditcard',
				'payment_method_google_pay': 'creditcard',
				'payment_method_paypal': 'paypal',
				'payment_method_satispay': 'satispay',
				'payment_method_wire_transfer': 'wire_transfer',
				'payment_method_at_location': 'at_location',
				'payment_method_other': 'other'
			};
			return mapping[frontendMethod] || null;
		}

		// Save selected payment method to server
		function savePaymentMethodSelection(paymentMethod) {
			var backendMethod = mapPaymentMethodToBackend(paymentMethod);
			var orderId = $(".order-summary-table").data("id_subscriptions_order");
			var confirmToken = $(".order-summary-table").data("confirm_token");

			if (backendMethod && orderId && confirmToken) {
				$.post(
					APP_ROOT + "/api/" + LOCALE + "/v1/subscriptions-order/set-payment-method",
					{
						id_subscriptions_order: orderId,
						confirm_token: confirmToken,
						payment_method: backendMethod
					}
				).fail(function(xhr, status, error) {
					console.warn('Failed to save payment method selection:', error);
				});
			}
		}

		// Handle click on payment card buttons
		$(".payment-card").on("click", function(e) {
			e.preventDefault();

			// Remove selected class from all cards
			$(".payment-card").removeClass("selected");

			// Add selected class to clicked card
			$(this).addClass("selected");

			// Update the hidden radio input
			var paymentMethod = $(this).data("payment-method");

			// Save payment method selection to server immediately
			savePaymentMethodSelection(paymentMethod);

			// Uncheck all radio inputs
			$(".payment-card input[type='radio']").prop("checked", false);

			// Check the clicked card's radio input
			$(this).find("input[type='radio']").prop("checked", true);

			// Hide all payment method boxes
			$(".payment-method-box").css("display", "none");

			// Show the selected payment method box
			var $paymentBox = $("#" + paymentMethod + "-box");
			$paymentBox.css("display", "block");

			// Update price display for payment method fees
			updatePaymentMethodFee(paymentMethod);

			// Mount Stripe Elements when credit card is selected (fix for mobile)
			if (paymentMethod === "payment_method_credit_card" && typeof window.mountStripeElements === "function") {
				setTimeout(function() {
					window.mountStripeElements();
				}, 50);
			}

			// Mount Apple Pay Button when selected
			if (paymentMethod === "payment_method_apple_pay") {
				if (applePayAvailable && applePayButton) {
					// Check if already mounted
					if (!$("#apple-pay-button-container").children().length) {
						// console.log('🔵 Mounting Apple Pay button');
						applePayButton.mount('#apple-pay-button-container');
					}
				} else {
					console.log('⚠️ Apple Pay selected but not available');
				}
			}

			// Mount Google Pay Button when selected
			if (paymentMethod === "payment_method_google_pay") {
				if (googlePayAvailable && googlePayButton) {
					// Check if already mounted
					if (!$("#google-pay-button-container").children().length) {
						// console.log('🔵 Mounting Google Pay button');
						googlePayButton.mount('#google-pay-button-container');
					}
				} else {
					// console.log('⚠️ Google Pay selected but not available');
				}
			}

			// Auto-scroll to the payment method box (useful on mobile)
			setTimeout(function() {
				if ($paymentBox.length > 0) {
					$('html, body').animate({
						scrollTop: $paymentBox.offset().top - 20
					}, 500);
				}
			}, 100);
		});

		// Handle keyboard navigation (Enter/Space)
		$(".payment-card").on("keypress", function(e) {
			if (e.which === 13 || e.which === 32) { // Enter or Space key
				e.preventDefault();
				$(this).click();
			}
		});

		// Initialize: if a card has data-selected="true", mark it as selected on page load
		$(".payment-card[data-selected='true']").addClass("selected");

		// Initialize: if a radio is checked on page load, mark its card as selected
		$(".payment-card input[type='radio']:checked").each(function() {
			$(this).closest(".payment-card").addClass("selected");
		});
	}

	/*
	 * Satispay payment handling
	 */
	if ($("#payment_method_satispay").length > 0) {
		$("#satispay-confirm-button").click(function(e) {
			e.preventDefault();

			// Submit the form to satispayPay route
			var form = $('<form>', {
				'method': 'POST',
				'action': APP_ROOT + '/' + LOCALE + '/' + satispay_pay_route
			});

			// Add CSRF token
			form.append($('<input>', {
				'type': 'hidden',
				'name': '_token',
				'value': $('meta[name="csrf-token"]').attr('content')
			}));

			$('body').append(form);
			form.submit();
		});
	}

	function updatePaymentMethodFee(paymentMethod) {
		// This function can be used to dynamically update the total price
		// based on the selected payment method fee
		// Implementation depends on whether you want real-time price updates
	}

	/*
	 * Order summary
	 */

	// delete subscriber
	if ($(".order-summary-table").length > 0) {
		$(".delete-subscriber-from-order-butt").click(function(evt) {
			evt.preventDefault();

			$butt = $(this);

			swal({
				text:
					"Sicuro di voler cancellare l'iscrizione di " +
					$(this)
						.parents("tr")
						.find(".name-column")
						.html() +
					" " +
					$(this)
						.parents("tr")
						.find(".surname-column")
						.html(),
				buttons: {
					cancel: {
						text: "Cancel",
						value: false,
						visible: true,
						className: "",
						closeModal: true
					},
					confirm: {
						text: "OK",
						value: true,
						visible: true,
						className: "",
						closeModal: true
					}
				}
			}).then(function(confirm) {
				var id_subscription = $butt.parents("tr").data("id_subscription");
				// console.log(id_subscription);

				if (confirm) {
					$.post(
						APP_ROOT +
							"/api/" +
							LOCALE +
							"/v1/race-manager/subscription/delete",
						{
							id_subscriptions: [id_subscription]
						},
						function(response) {
							$(".order-summary-table")
								.find('[data-id_subscription="' + id_subscription + '"]')
								.remove();
							location.reload(); // serve per aggiornare importo su payment intent stripe

							// $.post(
							// 	APP_ROOT + "/api/" + LOCALE + "/v1/subscriptions-order/get",
							// 	{
							// 		id_subscriptions_order: $(".order-summary-table").data(
							// 			"id_subscriptions_order"
							// 		)
							// 	},
							// 	function(subscriptions_order) {
							// 		$(".administration-fee").html(
							// 			subscriptions_order.administration_fee + " €"
							// 		);
							// 		$(".total-price").html(
							// 			subscriptions_order.total_to_pay + " €"
							// 		);
							// 		$(".clean-price").html(
							// 			subscriptions_order.clean_price + " €"
							// 		);
							// 	},
							// 	"json"
							// );
						},
						"json"
					);
				}
			});
		});
	}

	/*
	 * stripe
	 */

	if (typeof Stripe != "undefined") {

		var stripe = Stripe(stripe_pk);
		var elements = stripe.elements();
		var stripeMounted = false; // Flag to track if Stripe elements are mounted

		// Payment Request for Apple Pay / Google Pay
		var paymentRequest = null;
		var applePayButton = null;
		var googlePayButton = null;
		var applePayAvailable = false;
		var googlePayAvailable = false;

		var cardNumber = elements.create("cardNumber", {
			style: {
				base: {
					color: "#939393"
				}
			}
		});

		var cardExpiry = elements.create("cardExpiry", {
			style: {
				base: {
					color: "#939393"
				}
			}
		});

		var cvc = elements.create("cardCvc", {
			style: {
				base: {
					color: "#939393"
				}
			}
		});

		// Function to mount Stripe elements when payment method is selected
		window.mountStripeElements = function() {
			if (!stripeMounted && $("#payment_method_credit_card-box").is(":visible")) {
				cardNumber.mount("#card-number");
				cardExpiry.mount("#card-expiry");
				cvc.mount("#card-cvc");
				stripeMounted = true;
			}
		}

		// Mount immediately if credit card box is already visible (e.g., after validation errors)
		if ($("#payment_method_credit_card-box").is(":visible")) {
			window.mountStripeElements();
		}

		// Initialize Payment Request (Apple Pay / Google Pay)
		if (stripe && typeof stripe.paymentRequest === 'function') {

			// console.log('🔵 Stripe Payment Request API available');
			// console.log('🔵 Stripe instance:', stripe);

			// Get order details from DOM
			// Use total-amount-with-card-fee for Apple Pay/Google Pay as it includes the payment processing fees
			var orderAmount = parseInt($(".order-summary-table").data("total-amount-with-card-fee") * 100); // Convert to cents
			var orderDescription = $(".order-summary-table").data("description") || "Iscrizione gara";
			var orderId = $(".order-summary-table").data("id_subscriptions_order");

			console.log('🔵 Order details:', {
				amount: orderAmount,
				description: orderDescription,
				orderId: orderId,
				protocol: window.location.protocol,
				hostname: window.location.hostname
			});

			// Create Payment Request
			paymentRequest = stripe.paymentRequest({
				country: 'IT',
				currency: 'eur',
				total: {
					label: orderDescription,
					amount: orderAmount,
				},
				requestPayerName: true,
				requestPayerEmail: true,
			});

			// console.log('🔵 Payment Request created');

			// Check if Payment Request is available (Apple Pay or Google Pay)
			(async () => {
				// console.log('🔵 Checking wallet availability...');

				const result = await paymentRequest.canMakePayment();

				// console.log('🔵 canMakePayment result:', result);

				// // DEBUG: Alert per iPhone (rimuovere dopo test)
				// if (window.navigator.userAgent.indexOf('iPhone') > -1 || window.navigator.userAgent.indexOf('iPad') > -1) {
				// 	alert('DEBUG iPhone - canMakePayment: ' + JSON.stringify(result));
				// }

				if (result) {
					// Detect which wallet is available
					if (result.applePay) {
						applePayAvailable = true;
						$("#apple-pay-card").show();
						console.log('✅ Apple Pay available and shown');
					} else {
						console.log('❌ Apple Pay NOT available');
					}

					if (result.googlePay) {
						googlePayAvailable = true;
						$("#google-pay-card").show();
						console.log('✅ Google Pay available and shown');
					} else {
						console.log('❌ Google Pay NOT available');
					}

					// Create Payment Request Buttons
					var elementsForPR = stripe.elements();

					if (applePayAvailable) {
						applePayButton = elementsForPR.create('paymentRequestButton', {
							paymentRequest: paymentRequest,
							style: {
								paymentRequestButton: {
									type: 'default',
									theme: 'dark',
									height: '48px',
								},
							},
						});
					}

					if (googlePayAvailable) {
						googlePayButton = elementsForPR.create('paymentRequestButton', {
							paymentRequest: paymentRequest,
							style: {
								paymentRequestButton: {
									type: 'default',
									theme: 'dark',
									height: '48px',
								},
							},
						});
					}

				} else {
					// No wallet available - hide both cards
					$("#apple-pay-card").remove();
					$("#google-pay-card").remove();
					console.log('❌ No wallet payment available');
					// console.log('⚠️ Apple Pay requires HTTPS - current protocol:', window.location.protocol);
					// console.log('⚠️ If testing locally, Apple Pay will NOT work on http://localhost');
				}
			})();

			// Handle payment method submission
			paymentRequest.on('paymentmethod', async (ev) => {

				// console.log('🔵 Wallet payment initiated', ev.paymentMethod);

				// Get client secret from the payment intent
				var clientSecret = $("#submit-stripe").data("secret");

				if (!clientSecret) {
					// console.error('❌ No client secret found');
					ev.complete('fail');
					return;
				}

				// console.log('🔵 Client secret found, confirming payment...');

				// Show loading dialog
				swal({
					title: swal_messages.payment_in_progress_dialog_title,
					text: swal_messages.payment_in_progress_dialog_text,
					buttons: false
				});

				// Confirm payment with Stripe
				const {error: confirmError} = await stripe.confirmCardPayment(
					clientSecret,
					{
						payment_method: ev.paymentMethod.id
					},
					{
						handleActions: false
					}
				);

				if (confirmError) {
					// Payment failed
					// console.error('❌ Payment failed:', confirmError);
					ev.complete('fail');

					swal({
						icon: "error",
						title: swal_messages.error_card,
						text: confirmError.message || swal_messages.error_card_text
					});

				} else {
					// Payment succeeded
					// console.log('✅ Payment confirmed, calling fulfill-order...');
					ev.complete('success');

					// Call server to fulfill order
					$.post(
						APP_ROOT + "/api/" + LOCALE + "/v1/subscribe/fulfill-order",
						{
							id_subscriptions_order: orderId,
							// Il server verifica il PaymentIntent su Stripe prima di confermare l'ordine
							payment_intent_id: clientSecret.split('_secret_')[0]
						},
						function(res) {
							// console.log('🔵 Fulfill-order response:', res);
							if (!res.error_type) {
								// Redirect to success page
								// console.log('✅ Order fulfilled, redirecting...');
								window.location = res.route;
							} else {
								// console.error('❌ Fulfill-order error:', res);
								swal({
									icon: "error",
									title: swal_messages.error_card,
									text: swal_messages.error_card_text
								});
							}
						}
					).fail(function(xhr, status, error) {
						// console.error('❌ Fulfill-order request failed:', {xhr, status, error});
						swal({
							icon: "error",
							title: swal_messages.error_card,
							text: (xhr.responseJSON && xhr.responseJSON.message) || swal_messages.error_card_text
						});
					});
				}
			});
		} else {
			console.log('⚠️ Stripe Payment Request API not available');
			// console.log('⚠️ Stripe instance:', typeof Stripe !== 'undefined' ? 'defined' : 'undefined');
			// console.log('⚠️ stripe variable:', typeof stripe !== 'undefined' ? 'defined' : 'undefined');
		}

		var inputs = document.querySelectorAll("input.field");

		Array.prototype.forEach.call(inputs, function(input) {
			input.addEventListener("focus", function() {
				input.classList.add("is-focused");
			});
			input.addEventListener("blur", function() {
				input.classList.remove("is-focused");
			});
			input.addEventListener("keyup", function() {
				if (input.value.length === 0) {
					input.classList.add("is-empty");
				} else {
					input.classList.remove("is-empty");
				}
			});
		});

		document
			.querySelector(".stripe-form")
			.addEventListener("submit", function(e) {

				e.preventDefault();

				var cardholderName = document.getElementById('cardholder-name');
				var cardButton = document.getElementById('submit-stripe');
				var clientSecret = cardButton.dataset.secret;

				swal({
					title: swal_messages.payment_in_progress_dialog_title,
					text: swal_messages.payment_in_progress_dialog_text,
					buttons: false
				});

				$("#submit-stripe").prop("disabled", true);

				stripe.handleCardPayment(

					clientSecret, cardNumber, {
						payment_method_data: {
							billing_details: {name: cardholderName.value}
						}
					}

				).then(function(result) {

					if (result.error) {

						$("#submit-stripe").prop("disabled", false);
						swal({
							icon: "error",
							title: swal_messages.error_card,
							text: swal_messages.error_card_text
						});

					} else {

						if( result.paymentIntent.status == 'succeeded') {

							$.post(
								APP_ROOT + "/api/" + LOCALE + "/v1/subscribe/fulfill-order",
								{
									id_subscriptions_order: $(".order-summary-table").data("id_subscriptions_order"),
									// Il server verifica il PaymentIntent su Stripe prima di confermare l'ordine
									payment_intent_id: result.paymentIntent.id
								},
								function(res) {
									if (!res.error_type) {
										window.location = res.route;
									} else {
										$("#submit-stripe").prop("disabled", false);
										swal({
											icon: "error",
											title: swal_messages.error_card,
											text: res.message || swal_messages.error_card_text
										});
									}
								}
							).fail(function(xhr) {
								// Pagamento addebitato ma non confermabile (es. importo diverso): il
								// messaggio del server spiega cosa fare, l'ordine resta da verificare.
								$("#submit-stripe").prop("disabled", false);
								swal({
									icon: "error",
									title: swal_messages.error_card,
									text: (xhr.responseJSON && xhr.responseJSON.message) || swal_messages.error_card_text
								});
							});

						}

						// console.log('success')
						// window.location = res.route;

					}

				});

			});

	}

	/*
	 * Italian Tax Code (Codice Fiscale) validation - WARNING only
	 */
	function validateItalianTaxCode(taxCode) {
		// Basic format validation: 16 alphanumeric characters
		// Format: RSSMRA85T10A562S (6 letters + 2 digits + 1 letter + 2 digits + 1 letter + 3 digits + 1 letter)
		const taxCodeRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;

		if (!taxCode || taxCode.length === 0) {
			return { valid: true, message: '' }; // Empty is allowed, server will handle if required
		}

		taxCode = taxCode.toUpperCase().trim();

		if (!taxCodeRegex.test(taxCode)) {
			return {
				valid: false,
				message: LOCALE === 'it' ?
					'Il formato del Codice Fiscale non è corretto. Deve essere composto da 16 caratteri.' :
					'Tax Code format is incorrect. It must be 16 characters long.'
			};
		}

		// Additional validation: check control character (last digit)
		const evenMap = { '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, 'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9, 'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19, 'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25 };
		const oddMap = { '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21, 'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9, 'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21, 'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11, 'P': 3, 'Q': 6, 'R': 8, 'S': 12, 'T': 14, 'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23 };

		let sum = 0;
		for (let i = 0; i < 15; i++) {
			const char = taxCode.charAt(i);
			sum += i % 2 === 0 ? oddMap[char] : evenMap[char];
		}

		const expectedCheck = String.fromCharCode(65 + (sum % 26));
		const actualCheck = taxCode.charAt(15);

		if (expectedCheck !== actualCheck) {
			return {
				valid: false,
				message: LOCALE === 'it' ?
					'Il Codice Fiscale inserito non è valido. Verifica di aver inserito correttamente tutti i caratteri.' :
					'The entered Tax Code is not valid. Please verify you have entered all characters correctly.'
			};
		}

		return { valid: true, message: '' };
	}

	function showTaxCodeWarning(message) {
		$('#tax-code-warning-message').text(message);
		$('#tax-code-warning').slideDown(200);
	}

	function hideTaxCodeWarning() {
		$('#tax-code-warning').slideUp(200);
	}

	// Validate tax code when nationality changes or fiscal code is entered
	// requireTaxCode values: 0=no, 1=optional (warn only), 2=required (blocking handled server-side)
	function checkTaxCodeValidation() {
		const nationality = $('#nationality').val();
		const taxCode = $('#fiscal_code').val();
		const requireTaxCode = parseInt($('#fiscal_code').data('require-tax-code'), 10) || 0;

		// Only show client-side warning for Italian tax codes when the field is active (level 1 or 2)
		if (requireTaxCode > 0 && (nationality === 'IT' || nationality === 'Italy')) {
			const validation = validateItalianTaxCode(taxCode);

			if (!validation.valid && taxCode.length > 0) {
				showTaxCodeWarning(validation.message);
			} else {
				hideTaxCodeWarning();
			}
		} else {
			hideTaxCodeWarning();
		}
	}

	// Attach event listeners
	$('#nationality').on('change', function() {
		checkTaxCodeValidation();
	});

	$('#fiscal_code').on('blur', function() {
		checkTaxCodeValidation();
	});

	$('#fiscal_code').on('input', function() {
		// Convert to uppercase as user types
		const cursorPos = this.selectionStart;
		this.value = this.value.toUpperCase();
		this.setSelectionRange(cursorPos, cursorPos);

		// Validate on input but with a small delay
		clearTimeout(window.taxCodeValidationTimeout);
		window.taxCodeValidationTimeout = setTimeout(function() {
			checkTaxCodeValidation();
		}, 500);
	});

	// Initial check on page load
	if ($('#fiscal_code').length > 0) {
		checkTaxCodeValidation();
	}

});
